export default "__VITE_ASSET__Jlb$sRfi__"